import { createFileRoute } from "@tanstack/react-router";
import { supabase } from "@/integrations/supabase/client";
import { seo } from "@/lib/seo";
import Blog from "@/pages/Blog";

export const Route = createFileRoute("/_site/blog/")({
  // Loaded here so the post list is server-rendered. Previously the index
  // fetched client-side and shipped zero post links to crawlers, leaving the
  // published posts with no internal links pointing at them.
  loader: async () => {
    const { data } = await supabase
      .from("blog_posts")
      .select("*")
      .eq("published", true)
      .or("scheduled_at.is.null,scheduled_at.lte.now()")
      .order("created_at", { ascending: false });
    return { posts: data ?? [] };
  },
  head: () => ({
    ...seo({
      title: "Roofing & Exterior Tips Blog | Kodiak Structures & Exteriors",
      description:
        "Expert roofing tips, exterior maintenance guides, and home improvement insights from Kodiak Structures & Exteriors.",
      path: "/blog",
    }),
  }),
  component: Blog,
});
